module.exports = __webpack_public_path__ + "img/infation.c131eb66.jpg";